import React, { forwardRef } from 'react';
import { Radio as AntRadio } from 'antd';
import Button from './button';
import Card from './card';
import Group from './group';
import CardGroup from './card-group';

/**
 * A radio button
 *
 * {@link https://ant.design/components/radio#api}
 *
 * @module Radio
 * @param {Object} props - the radio props
 * @param {string} [props.status] - the radio button status
 * @param {string} [props.size] - the radio button size
 * @param {string} [props.statusClass] - the radio button status class name
 * @param {string} [props.sizeClass] - the radio button size class name
 * @returns {React.ReactElement} - a radio button
**/
const Radio = forwardRef( ( { ...props }, ref ) => {

    const statusClass = props.status ? `origami-radio-${ props.status }` : '';
    const sizeClass = props.size ? props.size : 'small';

    return (
        <AntRadio
            ref={ ref }
            className={ `${ statusClass } ${ sizeClass }` }
            { ...props }
        />
    );
} );

Radio.Group = Group;
Radio.Button = Button;
Radio.Card = Card;

export { CardGroup };
export { Card as NackleSelectCard };
export { Radio };
